import React, { useState } from 'react';
import {Button, makeStyles, Tooltip} from '@fluentui/react-components';
import {ThumbLikeRegular, ThumbDislikeRegular} from '@fluentui/react-icons';
import { FeedbackDialog } from './FeedbackDialog';
import { Feedback, FeedbackRating, FeedbackContext } from '../types/feedback';




type FeedbackButtonsProps = {
    chatId: string;
    chatMessageId: string;
    agentId: string;
    context: FeedbackContext;
    feedback?: Feedback;
    onFeedbackChange?: (feedback?: Feedback) => void;
};
const useStyles = makeStyles({
    feedbackButtons: {
        display: 'flex',
        gap: '8px',
    },

    feedbackButton: {
        backgroundColor: 'var(--bg-color)',
        borderRadius: '8px',
        padding: '6px',
        minWidth: 'unset',


        '& span': {
            margin: 0,
        },

        '&:hover': {
            backgroundColor: 'color-mix(in srgb, var(--bg-color) 85%, black)',
        },

        '&:active': {
            backgroundColor: 'color-mix(in srgb, var(--bg-color) 70%, black)',
        },
    },
});



export const FeedbackButtons: React.FC<FeedbackButtonsProps> = ({
                                                                    chatId,
                                                                    chatMessageId,
                                                                    agentId,
                                                                    context,
                                                                    feedback,
                                                                    onFeedbackChange,
                                                                }) => {
    const [dialogOpen, setDialogOpen] = useState(false);
    const [dialogRating, setDialogRating] = useState<FeedbackRating | null>(null);
    const styles = useStyles();

    const handleButtonClick = (rating: FeedbackRating) => {
        setDialogRating(rating);
        setDialogOpen(true);
    };

    const handleDialogFeedbackChange = (fb?: Feedback) => {
        onFeedbackChange?.(fb);
        setDialogOpen(false);
    };


    return (
        <>
            <div className={styles.feedbackButtons}>
                <Tooltip content="Gute Antwort" relationship="label">
                    <Button
                        className={styles.feedbackButton}
                        icon={<ThumbLikeRegular />}
                        appearance="subtle"
                        onClick={() => handleButtonClick(FeedbackRating._Positive)}
                        aria-label="Gute Antwort"
                    />
                </Tooltip>

                <Tooltip content="Schlechte Antwort" relationship="label">
                    <Button
                        className={styles.feedbackButton}
                        icon={<ThumbDislikeRegular />}
                        appearance="subtle"
                        onClick={() => handleButtonClick(FeedbackRating._Negative)}
                        aria-label="Schlechte Antwort"
                    />
                </Tooltip>
            </div>

            {dialogOpen && dialogRating !== null && (
                <FeedbackDialog
                    isOpen={dialogOpen}
                    onClose={() => setDialogOpen(false)}
                    rating={dialogRating}
                    context={context}
                    chatId={chatId}
                    chatMessageId={chatMessageId}
                    agentId={agentId}
                    initialFeedback={feedback?.rating === dialogRating ? feedback : undefined}
                    onFeedbackChange={handleDialogFeedbackChange}
                />
            )}
        </>
    );
};